import { getAxiosInstance } from '../client';
/** Typed API functions for exercise favourites */
export const exerciseFavouritesQueries = {
    /** GET /users/:userId/exercise-favourites */
    getByUser: (userId) => getAxiosInstance()
        .get(`/users/${userId}/exercise-favourites`)
        .then((r) => r.data),
};
/** Query keys for exercise favourites - use with TanStack Query */
export const exerciseFavouritesKeys = {
    all: () => ['exercise-favourites'],
    byUser: (userId) => ['exercise-favourites', 'user', userId],
};
//# sourceMappingURL=exercise-favourites.queries.js.map